import moment from 'moment'
import * as R from 'ramda'

import {
  DEADLINE_FIELD,
  KIND_FIELD,
  MESSAGE_FIELD,
  MESSAGES_FIELD,
  RECEIVER_FIELD,
  SENDER_FIELD,
  SUBJECT_FIELD,
  TEMPLATE_ID_FIELD,
  getTemplate,
  JOB_STATUSES,
  WORKSPACE_STATUSES,
  JOB_TEMPLATE_MODE,
} from './model'

export const mapPropsToInternalState = state => {
  const {
    candidates = [],
    company,
    deadline,
    name: projectName,
    templates = [],
    mode = JOB_TEMPLATE_MODE,
  } = state ?? {}

  return {
    [MESSAGES_FIELD]: R.map(candidate => {
      const {
        timestamps = {},
        email,
        id,
        language,
        name,
        quiz_url,
        status,
      } = candidate

      const template = getTemplate({ language, status, templates, mode })

      const term = moment(timestamps?.deadline || deadline).format('YYYY-MM-DD')

      const interpolate = text =>
        R.pipe(
          R.replace(/\{{2}\s*\w+\s*\}{2}/g, match => {
            if (R.includes('name', match)) return name
            if (R.includes('deadline', match))
              return moment(term)
                .locale(language)
                .format('LL')
            if (R.includes('url', match)) return quiz_url
            if (R.includes('contact_email', match)) return 'ebber@ebber.com'

            if (mode === JOB_TEMPLATE_MODE) {
              if (R.includes('company', match)) return company
              if (R.includes('project', match)) return projectName
              if (R.includes('url', match)) return quiz_url
            }

            return ''
          }),
          R.trim,
        )(text || '')

      return {
        key: id,
        [DEADLINE_FIELD]: term,
        [KIND_FIELD]:
          mode === JOB_TEMPLATE_MODE
            ? JOB_STATUSES[status]
            : WORKSPACE_STATUSES[status],
        [RECEIVER_FIELD]: email,

        [SENDER_FIELD]: template?.sender_name ?? '',

        [SUBJECT_FIELD]: interpolate(template?.subject),

        [MESSAGE_FIELD]: interpolate(template?.body),

        [TEMPLATE_ID_FIELD]: template?.id ?? null,
      }
    }, candidates),
  }
}
